import { AppRoot } from '@vkontakte/vkui';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { addAITariffToolbarListeners } from 'reactApp/appHelpers/aiTariffToolbarHelpers';
import {
    BUILD_VERSION,
    IS_BIZ_USER,
    IS_DOCUMENTS_DOMAIN,
    IS_MY_TEAM,
    IS_PROMO_LANDOS,
    IS_REACT_LANDINGS,
} from 'reactApp/appHelpers/configHelpers';
import { AI_TARIFF_TOOLBAR_TOOLTIP_ENABLED } from 'reactApp/appHelpers/featuresHelpers/features/aiTariffToolbarTooltip';
import { ENABLE_ALLDOCUMENTS_FOR_BIZ } from 'reactApp/appHelpers/featuresHelpers/features/enableAlldocumentsForBiz';
import { ThemeOutsourceHelpers } from 'reactApp/appHelpers/themeToolHelpers';
import { useOrientation } from 'reactApp/hooks/useOrientation';
import useWorkspaceSuperappNavigation from 'reactApp/hooks/useWorspaceSuperappNavigation';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { initMedia } from 'reactApp/modules/media/media.helpers';
import { initPromoManager } from 'reactApp/modules/promoNew/manager/init';
import { AppRouter } from 'reactApp/ui/App/AppRouter';
import { DocumentsRouter } from 'reactApp/ui/App/DocumentsRouter';
import { useDataContainer } from 'reactApp/ui/App/effect/useDataContainer';
import { RotateScreen } from 'reactApp/ui/RotateScreen/RotateScreen';
import { changeDocumentDomainToCloud } from 'reactApp/utils/documentsDomain';
import { sendDwh } from 'reactApp/utils/ga';
import opener from 'reactApp/utils/opener';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

initMedia();
initPromoManager();
ThemeOutsourceHelpers.applyBodyTheme();

export const App = () => {
    const { title } = useDataContainer();
    const isPhone = EnvironmentSelectors.isPhone();
    const { isPortrait } = useOrientation();

    useWorkspaceSuperappNavigation();

    useEffect(() => {
        if (AI_TARIFF_TOOLBAR_TOOLTIP_ENABLED) {
            addAITariffToolbarListeners();
        }
    }, []);

    useEffect(() => {
        sendDwh({
            eventCategory: ECategoryGa.entered,
            action: 'app_load',
            dwhData: { build: BUILD_VERSION, place: isPhone ? 'touch' : 'web' },
        });
    }, [isPhone]);

    if (isPhone && IS_MY_TEAM && !isPortrait) {
        return <RotateScreen />;
    }
    // Редиректим B2B пользователей в хомяк, если они попали в Документы
    if (IS_BIZ_USER && !ENABLE_ALLDOCUMENTS_FOR_BIZ) {
        if (window.location.pathname.includes('/alldocuments/')) {
            window.location.href = '/home/';
        } else if (IS_DOCUMENTS_DOMAIN) {
            const url = `${changeDocumentDomainToCloud(window.location.origin)}/home/`;
            opener(url, true);
        }
    }
    return (
        <>
            {/* На реакт-лендосах ставим мета в Meta, на обычных - в самих лендосах */}
            {!IS_REACT_LANDINGS && !IS_PROMO_LANDOS && (
                <Helmet>
                    <title>{title}</title>
                </Helmet>
            )}
            {/**
             * Подключаем vkui в режиме partial.
             * Почитать подробнее [тут]{@link https://vkcom.github.io/VKUI/#/Modes}
             */}
            <AppRoot mode="partial">{IS_DOCUMENTS_DOMAIN ? <DocumentsRouter /> : <AppRouter />}</AppRoot>
        </>
    );
};
